import Link from "../link/Link";
import styles from "./hiddenNav.module.scss";

interface HiddenNavProps {
  links: { label: string; slug: string }[];
}

export default function HiddenNav({ links }: HiddenNavProps) {
  return (
    <nav className={styles.hiddenNav}>
      <ul>
        {links.map((link) => (
          <li key={link.slug}>
            <Link next href={link.slug}>
              {link.label}
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  );
}
